"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicReadSchema = exports.TopicReadBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
exports.TopicReadBaseSchema = zod_1.z.object({
    userId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    postId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    lastSeenAt: zod_1.z.coerce.date(),
});
exports.TopicReadSchema = exports.TopicReadBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
//# sourceMappingURL=TopicRead.js.map